import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SectionMessage, { SectionMessageAction } from "@atlaskit/section-message";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Oauth2RedirectPage = () => {
  useEffect(() => {}, []);
  let query = useQuery();

  const isErrors = query.get("isErrors");
  const errorMessage = query.get("errorMessage");
  const _time = query.get("_time");

  const returnMessage = () => {
    return (
      <>
        <br />
        OAuth2 authorization
        {isErrors == "true" && (
          <>
            <br />
            <div className="ihub-failed">FAILED</div>
            <br /> {JSON.stringify(errorMessage)}
          </>
        )}
        {isErrors == "false" && (
          <>
            <br />
            <div className="ihub-success">GRANTED</div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      {" "}
      <div className="ihub-public-main">
        <center>
          <h1>
            {_time && returnMessage()}
            {(_time == undefined || _time == null) && 404}
          </h1>
        </center>{" "}
        {isErrors && isErrors == "true" && _time != undefined && (
          <SectionMessage title="Things to check" actions={[]}>
            <ul>
              <li>Check Client Id</li>
              <li>Check Client Secret</li>
              <li>Check Access Token URL</li>
            </ul>
          </SectionMessage>
        )}{" "}
        {isErrors && isErrors == "false" && _time != undefined && (
          <SectionMessage title="Successesfully authorized" actions={[]}>
            <p>Close this window to return to Integration Hub for Jira</p>
          </SectionMessage>
        )}
      </div>
    </>
  );
};
export default Oauth2RedirectPage;
